import { render, staticRenderFns } from "./add-question.vue?vue&type=template&id=3523a852&scoped=true&"
import script from "./add-question.vue?vue&type=script&lang=js&"
export * from "./add-question.vue?vue&type=script&lang=js&"
import style0 from "./add-question.vue?vue&type=style&index=0&id=3523a852&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3523a852",
  null
  
)

export default component.exports